import React from 'react';
import ReactDOM from 'react-dom/client';
import CourseContainer from "./components/CourseContainer";
import "./App.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CourseContainer />
);